import { GdprEraseStatus, ResponseCode } from '@ul/api';

export const toGdprResponseCode = (status: GdprEraseStatus): ResponseCode => {
    switch (status) {
        case GdprEraseStatus.AllowDeletion:
            return ResponseCode.AllowDeletion;
        case GdprEraseStatus.UpComingBooking:
            return ResponseCode.UpComingBooking;
        case GdprEraseStatus.PastBookingTooRecent:
            return ResponseCode.PastBookingTooRecent;
        case GdprEraseStatus.HasSpecialRole:
            return ResponseCode.HasSpecialRole;
        case GdprEraseStatus.DeletionIncomplete:
            return ResponseCode.DeletionIncomplete;
        default:
            return ResponseCode.ErrorOccurred;
    }
};
